<template>
    <div class="page-footer-wrapper " :class="[$t('PageNavigate.classLang'), $t('common.fontFamily')]">
        <div class="page-footer-navigate-box-bg">
            <div class="page-footer-navigate-box">
                <div class="page-footer-logo-box">
                    <div class="page-footer-logo">
                        <a href="/">
                            <img v-if="$t('common.requestLang') == 'zh_CN'" src="@/assets/image/navigate/ebcZh.svg" alt="" />
                            <img v-else-if="$t('common.requestLang') == 'zh_TW'" src="@/assets/image/navigate/ebcZh-tw.svg" alt="" />
                            <img v-else-if="$t('common.requestLang') == 'th_TH'" src="@/assets/image/navigate/ebcTh.svg" alt="" />
                            <img v-else-if="$t('common.lang') == 'vi'" src="@/assets/image/navigate/ebcVn.svg" alt="" />
                            <img v-else-if="$t('common.requestLang') == 'ja_JP'" src="@/assets/image/navigate/ebcJp.svg" alt="" />
                            <img v-else-if="$t('common.requestLang') == 'ko_KR'" src="@/assets/image/navigate/ebcKr.png" alt="" />
                            <img v-else src="@/assets/image/navigate/ebcEn.svg" alt="" />
                        </a>
                    </div>
                    </div>
                     
                <div class="page-footer-links pc">
                    <div class="page-footer-menu-list" v-for="(list, index) in $t('PageFooter.linkList')" :key="index">
                        <template v-for="(listItem, index2) in list" >
                            <div class="page-footer-menu-item-top-link">{{ listItem.title }}</div>
                            <a :href="item.link" v-for="(item, key) in listItem.list" :key="index2 + 'i' + key"> 
                                {{ item.label }} 
                            </a>

                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-footer-intro-bg">
            <div class="page-footer-intro" v-html="$t('PageFooter.context')">

            </div>
        </div>
        <div class="page-footer-bottom-box-bg">
            <div class="page-footer-bottom-box">
                <div class="page-footer-bottom">
                    <div>© 2026, EBC Financial Group (SVG) LLC. All Rights Reserved.</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { method } from 'lodash';


export default {
    data() {
        return {

        }
    },
    mounted() {
        // let toTopBtn = document.getElementsByClassName("to-top");
        // for (let i = 0; i < toTopBtn.length; i++) {
        //     toTopBtn[i].addEventListener("click", function () {
        //         window.scrollTo({
        //             top: 0,
        //             left: 0,
        //             behavior: "smooth",
        //         });
        //     });
        // }
        // window.dataLayer = window.dataLayer || [];

        // // function gtag() {
        // // 	dataLayer.push(arguments);
        // // }
        // // gtag('js', new Date());
        // // gtag('config', 'G-TJ431PDHZX');
        // window.__lc = window.__lc || {};
        // window.__lc.license = 12340599;
        // (function (n, t, c) {
        //     function i(n) {
        //         return e._h ? e._h.apply(null, n) : e._q.push(n)
        //     }
        //     var e = {
        //         _q: [],
        //         _h: null,
        //         _v: "2.0",
        //         on: function () {
        //             i(["on", c.call(arguments)])
        //         },
        //         once: function () {
        //             i(["once", c.call(arguments)])
        //         },
        //         off: function () {
        //             i(["off", c.call(arguments)])
        //         },
        //         get: function () {
        //             if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
        //             return i(["get", c.call(arguments)])
        //         },
        //         call: function () {
        //             i(["call", c.call(arguments)])
        //         },
        //         init: function () {
        //             var n = t.createElement("script");
        //             n.async = !0, n.type = "text/javascript", n.src =
        //                 "https://cdn.livechatinc.com/tracking.js", t.head.appendChild(n)
        //         }
        //     };
        //     !n.__lc.asyncInit && e.init(), n.LiveChatWidget = n.LiveChatWidget || e
        // }(window, document, [].slice))
    },
    methods: {
        toUp() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            this.$emit('up')
        },
        
    }
}
</script>

<style lang="scss" scoped>
@import url("../../assets/css/page-footer.css");
</style>